import { FC } from "react";
import { useRouter } from "next/router";

interface Props {
    label?: string;
}
const WidgetError: FC<Props> = () => {
    const { reload } = useRouter();
    return (
        <div className="mt-4 flex flex-col items-center justify-center">
            <img
                src="/images/error_state.svg"
                alt="Error State"
                className="w-80"
            />
            <div className="mt-4 flex flex-col items-center py-2 text-sm">
                <div>Couldn&apos;t fetch your data.</div>
                <div className="flex gap-1">
                    <div
                        className="cursor-pointer text-primary underline"
                        onClick={reload}
                    >
                        Reload the page
                    </div>
                    and try again
                </div>
            </div>
        </div>
    );
};

export default WidgetError;
